import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'


import { ModalTransactions } from './ModalTransactions'

export const ModalModule = ({ useFetchInit, access }) => {
    
    const { dataModal, toggle } = useFetchInit

    const { open, titleModal, componentModal, dataRequest } = dataModal
    // const { CONTENEDOR, NUMERO_BL, BOOKING, TYPE } = (dataRequest && dataRequest.data) || {}

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggle}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <IconButton aria-label='close' onClick={toggle}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>

                    {componentModal === 'ModalTransactions' && (
                        <ModalTransactions useFetchInit={useFetchInit} dataModal={dataModal} />
                    )}
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}